import {
  Directive,
  ElementRef,
  inject,
  input,
  OnChanges,
  OnInit,
} from '@angular/core';

@Directive({
  standalone: false,
  selector: '[gstarPrimeGridRowAccordion]',
})
export class PrimeGridRowAccordionDirective implements OnInit, OnChanges {
  private readonly elementRef = inject<ElementRef<HTMLDivElement>>(ElementRef);

  gstarPrimeGridRowAccordion = input<boolean>(false);
  isRowDisabled = input<boolean>(false);
  cellKey = input<string>('');
  cellsToExpand = input<string[]>([]);

  private previousExpanded = false;

  ngOnInit(): void {
    // Only proceed if the current cell is in the list of cells to expand
    // Improve performance
    if (!this.cellsToExpand().includes(this.cellKey())) {
      return;
    }

    this.updateClass();

    const rect = this.elementRef.nativeElement.getBoundingClientRect();
    this.elementRef.nativeElement.style.width = `${rect.width}px`;
  }

  ngOnChanges(): void {
    const isCurrentExpanded = this.gstarPrimeGridRowAccordion();
    if (isCurrentExpanded !== this.previousExpanded) {
      this.previousExpanded = isCurrentExpanded;
      this.updateClass();
    }
  }

  private updateClass(): void {
    if (!this.cellsToExpand().includes(this.cellKey())) {
      return;
    }
    if (!this.isRowDisabled()) {
      if (this.gstarPrimeGridRowAccordion()) {
        this.elementRef.nativeElement.classList.remove('collapsed');
      } else {
        this.elementRef.nativeElement.classList.add('collapsed');
      }
    }
  }
}
